import { useMemo } from 'react'
import { BigNumber } from '@ethersproject/bignumber'
import dateFormat from 'dateformat'
import { useTokenFactoryContract } from '../hooks/useContract'
import { useSingleCallResult } from '../state/multicall/hooks'

export function useTokenList(owner?: string,): any {
  const contract = useTokenFactoryContract(false)

  const inputs = useMemo(() => [owner], [owner])
  const tokenList = useSingleCallResult(contract, 'getUserCreateTokens', inputs).result
  const tokens = tokenList?.tokens || []
  const tokensView = tokens.map((item:any) => {
    return {
      amount: BigNumber.from(item.amount.toString()).div(`${10 ** item.decimals}`).toString(),
      decimals: item.decimals,
      symbol: item.symbol,
      tokenAddress: item.tokenAddress,
      time: dateFormat(item.time.toString() * 1000, 'mm-dd HH:MM'),
      timeStr: Number(item.time.toString())
    }
  })

  const tokenSort = tokensView.sort((a,b)=>{ return b.timeStr - a.timeStr})
  return tokenSort
}

export default useTokenList
